<template>
  <div>
    <div v-if="this.cpu.progress != null">
        <h5 style="line-height:0.1; margin-top: 18px; margin-bottom: -10px; font-size: 15px;"  :class="cpu.progress_color_text">{{ cpu.progress }} %</h5>
        <vs-progress :percent="cpu.progress" :color="cpu.progress_color">primary</vs-progress>
    </div>
    <div v-else>
      <!-- <h5 style="line-height:1.2; margin-top: 15px;">N/A</h5> -->
      <vs-avatar text="N/A" style="margin-top: 10px;"/>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";

  export default Vue.extend({
    name: "CpuUsageDeviceAgGridComponent",
    data() {
      return {
       cpu: {
            progress: null,
            progress_color: 'success',
            progress_color_text: 'text-success',
            progress_info: '',
            one_minute: '',
        },
      }
    },
    methods: {
         readableBytes(bytes) {
                if (bytes > 0){
                    let i = Math.floor(Math.log(bytes) / Math.log(1024)),
                        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                    return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i];
                }else{
                    return "Unknown"
                }

            }
    },
    mounted() {
        if (this.params.data.hasOwnProperty('system_info')) {
            if (this.params.data.system_info.hasOwnProperty('cpuload')) {
                if (this.params.data.system_info.cpuload!=="N/A") {
                    let cpu_load = parseFloat(this.params.data.system_info.cpuload)
                    this.cpu.progress = parseFloat(cpu_load.toFixed(2))
                    if (this.cpu.progress > 85) {
                        this.cpu.progress_color = 'danger'
                        this.cpu.progress_color_text = 'text-danger'
                    } else if (this.cpu.progress>=70 && this.cpu.progress <= 85 ) {
                        this.cpu.progress_color = 'warning'
                         this.cpu.progress_color_text = 'text-warning'
                    } else {
                        this.cpu.progress_color = 'success'
                        this.cpu.progress_color_text = 'text-success'
                    }
                } else {
                    this.cpu.progress = null
                }
             } else {
                this.cpu.progress = null
             }
                
                     
        } else {
            this.cpu.progress = null
        }
       
    }
        
  })
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 10%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .line-0 {
    line-height: 0;
  }
</style>